<template>
  <component :is="tag" ref="wrapRef" />
</template>
<script>
import { defineComponent, watch, ref, unref, onMounted } from 'vue'
import { toCanvas } from './qrcodePlus'
import { toDataURL } from 'qrcode'

export default defineComponent({
  props: {
    value: {
      type: [String, Array],
      default: null
    },
    // 参数
    options: {
      type: Object,
      default: () => {
        return {
          margin: 1
        }
      }
    },
    // 宽度
    width: {
      type: Number,
      default: 200
    },
    // 中间logo图标
    logo: {
      type: [String, Object],
      default: ''
    },
    // img 不支持内嵌logo
    tag: {
      type: String,
      default: 'canvas',
      validator: (v) => ['canvas', 'img'].includes(v)
    }
  },
  emits: { done: (data) => !!data, error: (error) => !!error },
  setup(props, { emit }) {
    const wrapRef = ref(null)
    async function createQrcode() {
      try {
        const { tag, value, options = {}, width, logo } = props
        const renderValue = String(value)
        const wrapEl = unref(wrapRef)
        if (!wrapEl) return

        if (tag === 'canvas') {
          const url = await toCanvas({
            canvas: wrapEl,
            width,
            logo: logo,
            content: renderValue,
            options: options || {}
          })
          emit('done', { url, ctx: (wrapEl).getContext('2d') })
          return
        }

        if (tag === 'img') {
          const url = await toDataURL(renderValue, {
            errorCorrectionLevel: 'H',
            width,
            ...options
          });
          (unref(wrapRef)).src = url
          emit('done', { url })
        }
      } catch (error) {
        emit('error', error)
      }
    }

    onMounted(createQrcode)

    // 监听参数变化重新生成二维码
    watch(
      props,
      () => {
        createQrcode()
      },
      {
        deep: true
      }
    )

    return { wrapRef }
  }
})
</script>
